module.exports = __webpack_public_path__ + "media/images/logo-61687dc01eec729b9b07fa03944bf2ef.png";